import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RegisterEffectsService } from './register_effects.service';
import { concatMap, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { saveData } from './register_actions_creator';

@Injectable()
export class RegisterEffects {

  saveData = createEffect(() => this.action$.pipe(
    ofType(saveData),
    concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
    map(([_, state]) => {
      let registerState = state['app']['signup']['register'];
      this.registerEffectsService.saveData(registerState);
    })),
    {
      dispatch: false
    });

  constructor(private action$: Actions,
              private store$: Store,
              private registerEffectsService: RegisterEffectsService
  ) {}
}
